module.exports = __webpack_public_path__ + "static/media/DownloadIcon.6335d5fe.svg";